import request from '@/utils/request';

//  账号登录
export function login(data) {
  return request.post('/api/account/login', data);
}

//  账号退出登录
export function logout(data) {
  return request.post('api/account/logout', data);
}

// 账号列表
export function getRoleList(params) {
  return request.get('/api/account/list', params);
}

// 删除账号
export function deleteRole(data) {
  return request.post('/api/account/delete', data);
}

// 新增账号
export function addRole(data) {
  return request.post('/api/account/save', data);
}

// 修改账号信息
export function editRole(data) {
  return request.post('/api/account/edit', data);
}

// 全国省级列表
export function feactProvinces() {
  return request.get('/api/provinces/list');
}

// 获取城市列表
export function feactCitys(params) {
  return request.get('/api/cities/list', params);
}

// 获取县区列表
export function feactAreas(params) {
  return request.get('/api/areas/list', params);
}

// 新闻分页列表
export function feactNotice(params) {
  return request.get('/api/news/list', params);
}

// 添加新闻
export function addNotice(data) {
  return request.post('/api/news/save', data);
}

// 删除新闻
export function deleteNotice(data) {
  return request.post('/api/news/delete', data);
}

// 获取新闻详情
export function queryNotice(params) {
  return request.get('/api/news/query', params);
}

// 编辑新闻
export function editNotice(data) {
  return request.post('/api/news/edit', data);
}

// 技术支持分页列表
export function feactTechnology(params) {
  return request.get('/api/technology/list', params);
}

// 添加技术支持
export function addTechnology(data) {
  return request.post('/api/technology/save', data);
}

// 删除技术支持
export function deleteTechnology(data) {
  return request.post('/api/technology/delete', data);
}

// 获取技术支持详情
export function queryTechnology(params) {
  return request.get('/api/technology/query', params);
}

// 编辑技术支持
export function editTechnology(data) {
  return request.post('/api/technology/edit', data);
}

// 照片墙分页列表
export function feactPhotowall(params) {
  return request.get('/api/collection/paging', params);
}

// 删除照片墙
export function deletePhotowall(data) {
  return request.post('/api/collection/delete', data);
}

// 添加照片墙
export function addPhotowall(data) {
  return request.post('/api/collection/save', data);
}

// 编辑照片墙
export function editPhotowall(data) {
  return request.post('/api/collection/edit', data);
}

// 添加照片墙日常照片
export function addPhoto(data) {
  return request.post('/api/photo/save', data);
}

// 获取照片墙日常照片
export function getPhotoList(params) {
  return request.get('/api/photo/list', params);
}

// 删除照片墙
export function deletePhoto(data) {
  return request.post('/api/photo/delete', data);
}

// 获取课程类别
export function getCourseCategory() {
  return request.get('/api/classification/list');
}

// 添加课程类别
export function addCourseCategory(data) {
  return request.post('/api/classification/save', data);
}

// 编辑课程类别
export function editCourseCategory(data) {
  return request.post('/api/classification/edit', data);
}

// 删除课程类别
export function deleteCourseCategory(data) {
  return request.post('/api/classification/delete', data);
}

// 课程列表
export function getCourseList(params) {
  return request.get('/api/course/paging', params);
}

// 删除课程
export function deleteCourse(data) {
  return request.post('/api/course/delete', data);
}

// 添加课程
export function addCourse(data) {
  return request.post('/api/course/save', data);
}

// 编辑课程
export function editCourse(data) {
  return request.post('/api/course/edit', data);
}

// 门店老师列表
export function getTeacherList(params) {
  return request.get('/api/teacher/list', params);
}

// 老师分页列表
export function getTeacherPage(params) {
  return request.get('/api/teacher/paging', params);
}

// 添加老师
export function addTeacher(data) {
  return request.post('/api/teacher/save', data);
}

// 编辑老师
export function editTeacher(data) {
  return request.post('/api/teacher/edit', data);
}

// 获取产品类别
export function getGoodsCategory() {
  return request.get('/api/categorize/list');
}

// 添加产品类别
export function addGoodsCategory(data) {
  return request.post('/api/categorize/save', data);
}

// 编辑产品类别
export function editGoodsCategory(data) {
  return request.post('/api/categorize/edit', data);
}

// 删除产品类别
export function deleteGoodsCategory(data) {
  return request.post('/api/categorize/delete', data);
}

// 获取产品品牌
export function getGoodsBrand() {
  return request.get('/api/brand/list');
}

// 添加产品品牌
export function addGoodsBrand(data) {
  return request.post('/api/brand/save', data);
}

// 编辑产品品牌
export function editGoodsBrand(data) {
  return request.post('/api/brand/edit', data);
}

// 删除产品品牌
export function deleteGoodsBrand(data) {
  return request.post('/api/brand/delete', data);
}

// 获取产品类别
export function getBannerList() {
  return request.get('/api/banner/list');
}

// 添加产品品牌
export function addBanner(data) {
  return request.post('/api/banner/save', data);
}

// 编辑产品品牌
export function editBanner(data) {
  return request.post('/api/banner/edit', data);
}

// 删除产品品牌
export function deleteBanner(data) {
  return request.post('/api/banner/delete', data);
}

// 获取工具列表
export function getToolList() {
  return request.get('/api/tool/list');
}

// 添加工具
export function addTool(data) {
  return request.post('/api/tool/save', data);
}

// 编辑工具
export function editTool(data) {
  return request.post('/api/tool/edit', data);
}

// 删除工具
export function deleteTool(data) {
  return request.post('/api/tool/delete', data);
}

// 获取解决方案列表
export function getSolutionList() {
  return request.get('/api/solution/list');
}

// 添加解决方案
export function addSolution(data) {
  return request.post('/api/solution/save', data);
}

// 编辑解决方案
export function editSolution(data) {
  return request.post('/api/solution/edit', data);
}

// 删除解决方案
export function deleteSolution(data) {
  return request.post('/api/solution/delete', data);
}

// 获取合作伙伴列表
export function getCooperateList() {
  return request.get('/api/cooperate/list');
}

// 添加合作伙伴
export function addCooperate(data) {
  return request.post('/api/cooperate/save', data);
}

// 编辑合作伙伴
export function editCooperate(data) {
  return request.post('/api/cooperate/edit', data);
}

// 删除合作伙伴
export function deleteCooperate(data) {
  return request.post('/api/cooperate/delete', data);
}

// 获取用户评价列表
export function getEvaluateList() {
  return request.get('/api/evaluate/list');
}

// 添加用户评价
export function addEvaluate(data) {
  return request.post('/api/evaluate/save', data);
}

// 编辑用户评价
export function editEvaluate(data) {
  return request.post('/api/evaluate/edit', data);
}

// 删除用户评价
export function deleteEvaluate(data) {
  return request.post('/api/evaluate/delete', data);
}

// 获取荣誉资质列表
export function getHonorList() {
  return request.get('/api/honor/list');
}

// 添加荣誉资质
export function addHonor(data) {
  return request.post('/api/honor/save', data);
}

// 编辑荣誉资质
export function editHonor(data) {
  return request.post('/api/honor/edit', data);
}

// 删除荣誉资质
export function deleteHonor(data) {
  return request.post('/api/honor/delete', data);
}

// 获取安全配置列表
export function getSafetyList() {
  return request.get('/api/safety/list');
}

// 添加安全配置
export function addSafety(data) {
  return request.post('/api/safety/save', data);
}

// 编辑安全配置
export function editSafety(data) {
  return request.post('/api/safety/edit', data);
}

// 删除安全配置
export function deleteSafety(data) {
  return request.post('/api/safety/delete', data);
}

// 获取安全配置详情
export function getSafetyDetail(params) {
  return request.get(`/api/safety/detail/${params.id}`);
}

// 获取菜单列表
export function getMenuList() {
  return request.get('/api/menu/list');
}

// 添加菜单
export function addMenu(data) {
  return request.post('/api/menu/save', data);
}

// 编辑菜单
export function editMenu(data) {
  return request.post('/api/menu/edit', data);
}

// 删除菜单
export function deleteMenu(data) {
  return request.post('/api/menu/delete', data);
}

// 产品列表
export function getGoodsList(params) {
  return request.get('/api/goods/list', params);
}

// 删除产品
export function deleteGoods(data) {
  return request.post('/api/goods/delete', data);
}

// 添加产品
export function addGoods(data) {
  return request.post('/api/goods/save', data);
}

// 添加产品多规格SKU
export function addSKU(data) {
  return request.post('/api/sku/save', data);
}

// 获取产品多规格SKU
export function getSKU(params) {
  return request.get('/api/sku/list', params);
}

// 编辑产品
export function editGoods(data) {
  return request.post('/api/goods/edit', data);
}

// 编辑产品多规格SKU
export function editSKU(data) {
  return request.post('/api/sku/edit', data);
}

// 删除产品多规格SKU
export function deleteSKU(data) {
  return request.post('/api/sku/delete', data);
}

// 获取订单列表
export function getOrderList(params) {
  return request.get('/api/orders/list', params);
}

// 删除咨询/订单
export function deleteOrder(data) {
  return request.post('/api/orders/delete', data);
}

// 订单发货
export function deliverOrder(data) {
  return request.post('/api/order/deliver', data);
}

// 获取公司信息
export function getCompanyInfo() {
  return request.get('/api/company/query?id=1');
}

// 更新公司信息
export function updateCompanyInfo(data) {
  return request.post('/api/company/edit', data);
}

// 用户列表
export function getUserList(params) {
  return request.get('/api/user/list', params);
}

// 删除用户
export function deleteUser(data) {
  return request.post('/api/user/delete', data);
}

// 修改用户信息
export function editUser(data) {
  return request.post('/api/user/edit', data);
}